(function() {
	'use strict';
	var $ = avm.require('cash');

	$(window).on('scroll', function() {
		var scrolledTop = window.pageYOffset
		var stickyBar = $('.sticky-bar')
		var comarisonTable = $('.js-comparison-table')
		if (!comarisonTable.length) {
			return
		}
		if (scrolledTop > comarisonTable.offset().top && scrolledTop < comarisonTable.offset().top + comarisonTable.outerHeight()) {
			stickyBar.addClass('hidden')
		} else {
			stickyBar.removeClass('hidden')
		}
	})

})();
